import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="w-full max-w-md card-shadow-soft" data-testid="forgot-card">
        <CardHeader>
          <CardTitle className="text-2xl" style={{ fontFamily: "Outfit" }}>Forgot your password?</CardTitle>
          <p className="text-sm text-muted-foreground">Enter your email and we'll send a reset link (valid for 60 minutes).</p>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="space-y-4">
              <p className="text-sm bg-secondary p-3 rounded-md" data-testid="forgot-sent">If <strong>{email}</strong> is registered, a reset link is on its way. Check your inbox (and spam folder).</p>
              <Button asChild variant="outline" className="w-full min-h-[44px]"><Link to="/login" data-testid="forgot-back-login">Back to sign in</Link></Button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label>Email</Label>
                <Input type="email" data-testid="forgot-email" value={email} onChange={(e) => setEmail(e.target.value)} required className="min-h-[44px]" />
              </div>
              {error && <div data-testid="forgot-error" className="text-sm text-destructive bg-destructive/10 p-2.5 rounded-md">{error}</div>}
              <Button type="submit" data-testid="forgot-submit" className="w-full min-h-[44px]" disabled={busy}>{busy ? "Sending…" : "Send reset link"}</Button>
              <div className="text-center text-sm"><Link to="/login" className="text-primary font-semibold hover:underline" data-testid="forgot-cancel">Back to sign in</Link></div>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
